<script>
    import Board from './Board.svelte';
</script>

<div>
    <Board/>
</div>